import avatarImage from "../../../assets/images/avatar.svg";

// Uses the same case identity layout as a global-search result.
const CaseIdentity = ({ caseData, children }) => (
  <>
    {caseData?.for_client && (
      <span className="case-field d-flex align-items-center row-21px m-r-0 p-0">
        <img
          src={caseData.for_client.profile_pic_19p || avatarImage}
          className="m-r-5"
          width="15"
          height="15"
          alt=""
          style={{
            background: "var(--primary-30)",
            borderRadius: "50%",
            objectFit: "cover",
            height: "15px",
            width: "15px",
          }}
        />
        {caseData.for_client.last_name}, {caseData.for_client.first_name}
      </span>
    )}
    <span className="case-field d-flex align-items-center row-21px m-r-0 p-0">
      {caseData?.case_type?.casetype_icon && (
        <span
          className="d-flex align-items-center justify-content-center m-r-5"
          style={{ width: 15, height: 15 }}
        >
          <img src={caseData.case_type.casetype_icon} width="15" height="15" alt="" />
        </span>
      )}
      {caseData?.case_type?.name}
    </span>
    {children}
  </>
);

export default CaseIdentity;
